export enum ReimbursementType {
  CONSULTATION = 'CONSULTATION',
  MEDICATION = 'MEDICATION',
  HOSPITALIZATION = 'HOSPITALIZATION',
  DIAGNOSTIC_TEST = 'DIAGNOSTIC_TEST',
  DENTAL = 'DENTAL',
  VISION = 'VISION',
  OTHER = 'OTHER',
}
